var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrolldown"},[_c('span',{staticClass:"scrolldown_icon"},[_c('font-awesome-icon',{attrs:{"icon":['far', 'angle-down']}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }